export default {
  setLessons(state, data) {
    state.lessons = data;
  },

  clearLessons(state) {
    state.lessons = [];
  },

  setLesson(state, data) {
    state.lesson = data;
  },

  clearLesson(state) {
    state.lesson = {};
  },
};
